import React from 'react';

const Loader = () => {
  return (
    <div className="ng-http-loader">
      <div className="backdrop"></div>
      <div className="spinner">
        <div className="sk-wave">
          <div className="sk-rect sk-rect1"></div>
          <div className="sk-rect sk-rect2"></div>
          <div className="sk-rect sk-rect3"></div>
          <div className="sk-rect sk-rect4"></div>
          <div className="sk-rect sk-rect5"></div>
        </div>
      </div>
      <style>{`
        .ng-http-loader {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 9999;
        }

        .backdrop {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #000;
          opacity: 0.3;
        }

        .spinner {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .sk-wave {
          margin: 40px auto;
          width: 70px;
          height: 40px;
          text-align: center;
          font-size: 10px;
          display: flex;
          gap: 1px;
          justify-content: center;
          align-items: flex-end;
        }

        .sk-wave .sk-rect {
          background-color: #4d4d4dff;
          height: 100%;
          width: 6px;
          -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
          animation: sk-stretchdelay 1.2s infinite ease-in-out;
        }

        .sk-wave .sk-rect1 {
          -webkit-animation-delay: -1.2s;
          animation-delay: -1.2s;
        }

        .sk-wave .sk-rect2 {
          -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s;
        }

        .sk-wave .sk-rect3 {
          -webkit-animation-delay: -1.0s;
          animation-delay: -1.0s;
        }

        .sk-wave .sk-rect4 {
          -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s;
        }

        .sk-wave .sk-rect5 {
          -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s;
        }

        @-webkit-keyframes sk-stretchdelay {
          0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
          20% { -webkit-transform: scaleY(1.0) }
        }

        @keyframes sk-stretchdelay {
          0%, 40%, 100% {
            transform: scaleY(0.4);
            -webkit-transform: scaleY(0.4);
          }  20% {
            transform: scaleY(1.0);
            -webkit-transform: scaleY(1.0);
          }
        }
      `}</style>
    </div>
  );
};

export default Loader;
